export default {
  description: 'Dit is jullie familie',
  add: 'Nog eentje',
  finish: 'Klaar!'
};
